document.addEventListener('DOMContentLoaded', function () {
  var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var activeImg = card.querySelector('[data-card-image="active"]');
    var swatches = card.querySelectorAll('.ed-card__swatch');
    var prevBtn = card.querySelector('.ed-card__arrow--prev');
    var nextBtn = card.querySelector('.ed-card__arrow--next');
    var sizesWrap = card.querySelector('.ed-card__sizes');
    var sizeEls = card.querySelectorAll('.ed-card__size');
    var cardLinks = card.querySelectorAll('.ed-card__image-link, .ed-card__title-link');

    var images = [];
    try {
      images = JSON.parse(card.getAttribute('data-images') || '[]');
    } catch (e) {
      images = [];
    }

    var sizesByColor = {};
    if (sizesWrap) {
      try {
        sizesByColor = JSON.parse(sizesWrap.getAttribute('data-sizes-by-color') || '{}');
      } catch (e) {
        sizesByColor = {};
      }
    }

    var currentIndex = 0;
    // Tracks the actual selected (clicked) image, independent of a temporary hover preview
    var committedSrc = activeImg ? activeImg.getAttribute('src') : null;

    function showIndex(i) {
      if (!activeImg || images.length === 0) return;
      currentIndex = ((i % images.length) + images.length) % images.length;
      activeImg.src = images[currentIndex];
      committedSrc = activeImg.src;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        showIndex(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        showIndex(currentIndex + 1);
      });
    }

    function updateSizesForColor(color) {
      var sizeList = sizesByColor[color];
      if (!sizeList) return;

      sizeEls.forEach(function (el) {
        var size = el.getAttribute('data-size');
        var match = sizeList.find(function (s) {
          return s.size === size;
        });
        if (match) {
          el.classList.toggle('ed-card__size--unavailable', !match.available);
        }
      });
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var newSrc = swatch.getAttribute('data-swap-image');
        if (newSrc && activeImg) {
          activeImg.src = newSrc;
          committedSrc = newSrc;
        }

        var newUrl = swatch.getAttribute('data-variant-url');
        if (newUrl) {
          cardLinks.forEach(function (link) {
            link.setAttribute('href', newUrl);
          });
        }

        swatches.forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');

        var color = swatch.getAttribute('data-color');
        if (color) {
          updateSizesForColor(color);
        }
      });

      if (supportsHover) {
        swatch.addEventListener('mouseenter', function () {
          var previewSrc = swatch.getAttribute('data-swap-image');
          if (previewSrc && activeImg) {
            activeImg.src = previewSrc;
          }
        });

        swatch.addEventListener('mouseleave', function () {
          if (activeImg && committedSrc) {
            activeImg.src = committedSrc;
          }
        });
      }
    });
  });
});
